const breakpoints = {
  xs: '@media only screen and (max-width: 425px)',
  sm: '@media only screen and (max-width: 767.98px)',
  md: '@media only screen and (max-width: 991.98px)',
  lg: '@media only screen and (max-width: 1280.98px)',
  xl: '@media only screen and (min-width: 1280.98px)',
};

export default breakpoints;
